import styled from "styled-components";

import { LoaderWithOverlay, SummaryItem } from "components/atoms";
import { useSelector } from "react-redux";
import { getReservationsReport } from "state/modules/reservations";
import { useMemo } from "react";

const Container = styled.div`
	display: grid;
	grid-template-columns: repeat(4, 1fr);
	gap: 15px;
	width: 100%;
	position: relative;

	@media (max-width: 1200px) {
		grid-template-columns: repeat(2, 1fr);
	}

	@media (max-width: 480px) {
		grid-template-columns: 1fr;
	}
`;

interface Props {
	isLoading: boolean;
}

const ReservationsSummary = (props: Props) => {
	const { isLoading } = props;

	const report = useSelector(getReservationsReport);

	const summaryItems = useMemo(() => {
		if (report) {
			return [
				{
					title: "Occupancy",
					value: `${(Math.round((report.calculations?.occupancyRate || 0) * 100) / 100).toFixed(2)}%`,
				},
				{
					title: "Nights Sold",
					value: `${report.reportItems?.reduce((prevValue, currentValue) => {
						const { nights } = currentValue;

						return prevValue + nights;
					}, 0)}`,
				},
				{
					value: `$${
						report.calculations?.totalInCurrency.totalIncomeInCurrency || 0
					}`,
					title: "Owner Income",
				},
				{
					value: `${report.calculations?.totalInCurrency.netOwnerIncomeInCurrency}$`,
					title: "Net Income (after exp)",
				},
				// {
				// 	title: "Hotelise Fee",
				// 	value: "$3.520",
				// },
			];
		}

		return [];
	}, [report]);

	return (
		<Container>
			{summaryItems.map((item) => (
				<SummaryItem key={item.title} value={item.value} title={item.title} />
			))}
			{isLoading ? <LoaderWithOverlay /> : null}
		</Container>
	);
};

export default ReservationsSummary;
